


export class Record {
    id:string | null = null;
}
